<script setup lang="ts">
import { VueDraggable } from "vue-draggable-plus";
import { ref, nextTick } from "vue";
import EventTypeCard from "./EventTypeCard.vue";
import route from "ziggy-js";

import { SortableEvent } from "sortablejs";
import type { EventTypeGroup } from "../EventTypes.vue";
import { router } from "@inertiajs/vue3";
import { PerfectScrollbar } from "vue3-perfect-scrollbar";

const props = defineProps<{
    eventTypes: any[];
    eventTypeGroup: EventTypeGroup;
}>();

const drag = ref(false);

const list = ref<any[]>([]);
const disabledList = ref<any[]>([]);

props.eventTypes.map((item) => {
    const found = props.eventTypeGroup.event_types.find((eventType) => {
        if (eventType.id === item.id) {
            return item;
        }
    });

    if (found) {
        list.value.push(found);
    } else {
        disabledList.value.push(item);
    }
});

list.value = list.value.sort((a, b) => {
    if (a.pivot.order > b.pivot.order) {
        return 1;
    } else {
        return -1;
    }
});

console.log(list.value);

function onEnd(_: SortableEvent) {
    nextTick(() => {
        drag.value = false;
    });

    console.log("test");

    reorder();
}

async function reorder() {
    try {
        await router.post(
            route("app.event-type-groups.reorder", {
                eventTypeGroup: props.eventTypeGroup.id,
            }),
            {
                order: list.value.map((item) => {
                    return item.id;
                }),
            },
            {
                onSuccess: () => {},
            },
        );
    } catch (err) {
        console.log(err);
    }
}

function onStart() {
    drag.value = true;
}

async function detachEventType(eventType: any) {
    try {
        router.post(
            route("app.event-type-groups.detach-event-type", {
                eventTypeGroup: props.eventTypeGroup.id,
            }),
            {
                eventTypeId: eventType.id,
            },
            {
                onSuccess: () => {
                    list.value = list.value.filter((item) => {
                        if (item.id !== eventType.id) {
                            return item;
                        }
                    });

                    disabledList.value.push(eventType);
                },
            },
        );
    } catch (err) {
        console.log(err);
    }
}

async function attachEventType(eventType: any) {
    try {
        await router.post(
            route("app.event-type-groups.assign-event-type", {
                eventTypeGroup: props.eventTypeGroup.id,
            }),
            {
                eventTypeId: eventType.id,
            },
            {
                onSuccess: () => {
                    list.value.push(eventType);

                    disabledList.value = disabledList.value.filter((item) => {
                        if (item.id !== eventType.id) {
                            return item;
                        }
                    });
                },
            },
        );
    } catch (err) {
        console.log(err);
    }
}

async function attachmentToggled(eventType: any) {
    const found = list.value.find((item) => {
        if (item.id === eventType.id) {
            return item;
        }
    });

    if (found) {
        await detachEventType(eventType);
    } else {
        await attachEventType(eventType);
    }
}
</script>
<template>
    <div class="mt-8">
        <PerfectScrollbar class="max-h-[500px]">
            <VueDraggable
                ref="el"
                v-model="list"
                :animation="150"
                target=".sort-target"
                handle=".event-card-handle"
                ghost-class="ghost"
                @end="onEnd"
                @start="onStart"
            >
                <TransitionGroup
                    type="transition"
                    tag="ul"
                    :name="!drag ? 'fade' : undefined"
                    class="sort-target"
                >
                    <li v-for="item in list" :key="item.uuid">
                        <EventTypeCard
                            :drag-disabled="false"
                            :enabled="true"
                            class="mt-4"
                            :event-type="item"
                            @toggle-attachment="attachmentToggled"
                        ></EventTypeCard>
                    </li>

                    <li v-for="item in disabledList" :key="item.uuid">
                        <EventTypeCard
                            :enabled="false"
                            class="mt-4"
                            :drag-disabled="true"
                            :event-type="item"
                            @toggle-attachment="attachmentToggled"
                        ></EventTypeCard>
                    </li>
                </TransitionGroup>
            </VueDraggable>
        </PerfectScrollbar>
    </div>
</template>

<style>
.fade-move,
.fade-enter-active,
.fade-leave-active {
    transition: all 0.5s cubic-bezier(0.55, 0, 0.1, 1);
}

.fade-enter-from,
.fade-leave-to {
    opacity: 0;
    transform: scaleY(0.01) translate(30px, 0);
}

.fade-leave-active {
    position: absolute;
}

.ghost {
    opacity: 0.5;
    background: #c8ebfb;
}
</style>
